import DashboardToAlertGrid from "presentation/components/Dashboard/DashboardToAlertGrid";
import DashboardToApprovalGrid from "presentation/components/Dashboard/DashboardToApprovalGrid";
import Spinner from "presentation/components/Shared/Spinner";
import usePermissionCheck from "presentation/hooks/use-check-permissions";
import { TabPanel, TabView } from "primereact/tabview";
import React from "react";
import FunctionHeader from "../../components/Header/FunctionHeader";
import { useAuthStore } from "presentation/stores/use-auth-store";

const DashboardPage = ({ children }: { children?: React.ReactNode }) => {
  const { isLoading } = usePermissionCheck({ requiredFunction: "dashboards" });
  const { userEmployee } = useAuthStore();
  if (isLoading) {
    return <Spinner />;
  }

  return (
    <div>
      <FunctionHeader title="Dashboard" />
      <TabView>
        {/* <TabPanel header="Avisos" leftIcon="pi pi-exclamation-circle mr-2">
          <DashboardToAlertGrid />
        </TabPanel> */}
        <TabPanel header="A Aprovar" leftIcon="pi pi-check-circle mr-2">
          <DashboardToApprovalGrid level={1} />
        </TabPanel>
        {userEmployee?.jobTitle.name.includes("CEO") && (
          <TabPanel header="A Assinar" leftIcon="pi pi-verified mr-2">
            <DashboardToApprovalGrid level={2} />
          </TabPanel>
        )}
      </TabView>
    </div>
  );
};

export default DashboardPage;
